module.exports = __webpack_public_path__ + "img/RedBag Logo with Radio White.eb492e5.png";